import { render } from "./themeSwitch.vue?vue&type=template&id=5221d5bb&scoped=true"
import script from "./themeSwitch.vue?vue&type=script&lang=js"
export * from "./themeSwitch.vue?vue&type=script&lang=js"

import "./themeSwitch.vue?vue&type=style&index=0&id=5221d5bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5221d5bb"]])

export default __exports__